import './Chip.css';

/* ============================================================================
   Chip — small pixel tag for HUD readouts, badges and status pills.
   tone: default | red | cyan | gold | lime | magenta
   ========================================================================== */

function Chip({ children, tone = 'default', icon = null, pulse = false, className = '', ...rest }) {
  return (
    <span
      className={`ui-chip ui-chip--${tone} ${pulse ? 'is-pulsing' : ''} ${className}`}
      {...rest}
    >
      {icon && <span className="ui-chip__icon">{icon}</span>}
      {children}
    </span>
  );
}

export default Chip;
